import api from "api"

import { getRandomNumber } from "@utils/getRandomNumber"

const size = "1440x1000"

export const unsplashApi = {
  random: `https://source.unsplash.com/collection/175083/${size}`,
  randomProfile: `https://source.unsplash.com/collection/175083/640x168`,
  randomSmaller: `https://source.unsplash.com/collection/175083/300x200`,
  dark: `https://source.unsplash.com/${size}/?dark`,
  gray: `https://source.unsplash.com/300x200/?gray`,
}

// #222 (P0, key-leak gate): Unsplash used to be called client-side via an unsplash-js client
// built from REACT_APP_UNSPLASH_ACCESS_KEY. Create-React-App inlines every REACT_APP_* var into
// the shipped bundle at compile time, so that key was exposed to every browser exactly like a
// hardcoded key. Both call sites now go through the backend provider proxy
// (api/routers/provider_proxy.py on coowe-platform, PR fix/222-provider-proxy-2026-07-10), which
// holds the real key server-side only. The proxy reshapes the response to
// {id, urls: {small, regular, full}, alt_description} and never returns a small_s3/amazonaws
// URL, so the old small/small_s3 fallback is gone — small is always present when a result exists.
export const searchUnsplashPhoto = async (keywordsString, isList) => {
  const { data } = await api.client.get("/v1/provider/unsplash/search", {
    params: {
      query: keywordsString.replaceAll(/\s+/g, "+"),
      page: getRandomNumber({ min: 1, max: 3 }),
      per_page: isList ? 10 : 1,
    },
  })
  const results = data?.results || []

  return isList ? results : results?.[0]?.urls?.small
}

export const getRandomUnsplashPhoto = async () => {
  try {
    const { data } = await api.client.get("/v1/provider/unsplash/random")
    if (!data) return

    return data?.urls?.small
  } catch (error) {
    console.log("error", error)
    return
  }
}
